import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Contact.css';
import LeftSection from './LeftSection';
import RightSection from './RightSection';

const Contact = () => {
    const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
    const [status, setStatus] = useState('');

    const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

    const handleSubmit = async (e) => {
        e.preventDefault();
        const res = await fetch('https://skcapi.btcjapan.co/contact.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(form)
        });
        const data = await res.text();
        setStatus(data);
        setForm({ name: '', email: '', subject: '', message: '' });
    };

    return (
        <div className="container-fluid p-0">
            <div className="row g-0">
                <div className="col-lg-2 d-none d-lg-block"><LeftSection /></div>
                <div className="col-lg-8 col-md-12">

                    {/* Banner */}
                    <div className="container-fluid p-3">
                        <div className="row g-0">
                            <div className="col-12">
                                <div className="contact-banner">
                                    <h1>Get in Touch With Us</h1>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Info Section */}
                    <div className="container my-5">
                        <div className="row text-center">
                            <div className="col-md-4 mb-4">
                                <i className="bi bi-geo-alt-fill display-5 text-primary"></i>
                                <h5 className="mt-3">Our Address</h5>
                                <p>1-18-11, OJIMA, KOTO KU,<br></br>
TOKYO, JAPAN 136-0072</p>
                            </div>
                            <div className="col-md-4 mb-4">
                                <i className="bi bi-telephone-fill display-5 text-primary"></i>
                                <h5 className="mt-3">Call Us</h5>
                                <p>+81-345-888-721</p>
                            </div>
                            <div className="col-md-4 mb-4">
                                <i className="bi bi-envelope-fill display-5 text-primary"></i>
                                <h5 className="mt-3">Email Us</h5>
                                <p>info@skcjapan.com</p>
                            </div>
                        </div>
                    </div>

                    {/* Contact Form */}
                    <div className="container py-4">
                        <h2 className="text-center mb-4 fw-bold">Contact Form</h2>
                        {status && <div className="alert alert-info text-center">{status}</div>}
                        <form onSubmit={handleSubmit} className="p-4 border rounded bg-white shadow-lg">
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <input type="text" className="form-control" placeholder="Name *" required name="name" value={form.name} onChange={handleChange} />
                                </div>
                                <div className="col-md-6">
                                    <input type="email" className="form-control" placeholder="Email *" required name="email" value={form.email} onChange={handleChange} />
                                </div>
                                <div className="col-12">
                                    <input type="text" className="form-control" placeholder="Subject" name="subject" value={form.subject} onChange={handleChange} />
                                </div>
                                <div className="col-12">
                                    <textarea className="form-control" rows="5" placeholder="Message *" required name="message" value={form.message} onChange={handleChange}></textarea>
                                </div>
                                <div className="col-12 text-center">
                                    <button type="submit" className="btn btn-primary px-5 py-2 fw-semibold">Send Message</button>
                                </div>
                            </div>
                        </form>
                    </div>

                    {/* Map Section */}
                    <div className="container-fluid my-5">
                        <h2 className="text-center mb-4 fw-bold">Our Location</h2>
                        <div className="ratio ratio-16x9 shadow rounded">
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3853.7890106657355!2d139.82025329026325!3d35.68593019919161!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601888e6096e9939%3A0xc84479d10d6f6d8b!2s1-ch%C5%8Dme-18-11%20%C5%8Cjima%2C%20Koto%20City%2C%20Tokyo%20136-0072%2C%20Japan!5e0!3m2!1sen!2s!4v1753461848870!5m2!1sen!2s"
                                loading="lazy"
                                title="Company Location">
                            </iframe>
                            
                        </div>
                    </div>
                </div>
                <div className="col-lg-2 d-none d-lg-block"><RightSection /></div>
            </div>
        </div>
    );
};

export default Contact;
